import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { firstValueFrom, map } from 'rxjs';
import { getAllRouteData } from '../../lib/get-all-route-data';
import { getFullPath } from '../../lib/get-full-path';
import { PICFLOW_STORYBLOK } from '../../picflow-storyblok';
import { JsonLDService } from '../../services/json-ld.service';

export const storyblokPageJsonLDGuard: CanActivateFn = async route => {
  const storyblokService = inject(PICFLOW_STORYBLOK);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const jsonLDService = inject(JsonLDService);

  const path = getAllRouteData(route).storyblokPathOverride || getFullPath(route).join('/') || 'home';

  const story = await firstValueFrom(
    storyblokService.getStory(path, route).pipe(map(resp => (resp && resp.story) || (false as const)))
  );

  if (!story) return true;

  // TODO add json-ld for storyblok page

  return true;
};
